import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content"]
    static values = { url: String, poiId: String }

    connect() {
        this._setAudioLoading(true)
        if (this.element.querySelector("[data-description-available='true']")) {
            this._prepareAudio()
        } else {
            this.load()
        }
    }

    async load() {
        try {
            const response = await fetch(this.urlValue, {
                headers: { Accept: "text/html" },
                credentials: "same-origin"
            })
            if (!response.ok) throw new Error("Description indisponible")

            this.contentTarget.innerHTML = await response.text()
            if (this.element.querySelector("[data-description-available='true']")) {
                await this._prepareAudio()
            }
        } catch (error) {
            this._setAudioLoading(false)
        }
    }

    async _prepareAudio() {
        try {
            const response = await fetch(`/pois/${this.poiIdValue}/audio_file`, {
                credentials: "same-origin"
            })
            if (!response.ok) throw new Error("TTS indisponible")
            this._setAudioLoading(false, true, await response.blob())
        } catch (error) {
            this._setAudioLoading(false, false)
        }
    }

    _setAudioLoading(loading, ready = false, audioBlob = null) {
        document.dispatchEvent(new CustomEvent("poi:audio-preparation", {
            detail: { poiId: this.poiIdValue, loading, ready, audioBlob }
        }))
    }
}
